/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.code",
    title: "Email Code",
    description: "Displays a large centered sign-in code and a description line below it.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "code": {
            title: "Code",
            type: "string",
            description: "The formatted sign-in code, e.g. \"1234-5678-9012\".",
            required: true
        },
        "description": {
            title: "Description",
            type: "string",
            description: "Short description below the code, e.g. \"to continue\".",
            required: false,
            default: "to continue"
        }
    }
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.code",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var code        = (options && options.code)        ? options.code        : "";
    var description = (options && options.description) ? options.description : "to continue";
    var cfg = $.config;
    var primary = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.primary) || "#C48D2F";

    var html = `<tr>
  <td align="center" style="padding:30px 20px;">
    <div style="font-family:Arial,Helvetica,sans-serif;font-size:36px;font-weight:bold;letter-spacing:6px;color:${primary};text-align:center;">
      ${code}
    </div>
    <div style="font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#ADB5BD;text-align:center;margin-top:8px;">
      ${description}
    </div>
  </td>
</tr>`;

    var text = `Your code: ${code}\n${description}`;

    return { html, text };
};
